<template>
  <div class="synops" @click="gotodetails()">
    <div class="job-title">{{ title }}</div>
    <div class="date">
      <v-icon
        style="color: var(--icon-grey-scale-color); margin-right: .5rem; margin-bottom: .2rem;"
        size="14"
        >mdi-clock</v-icon
      ><span
        >Open date: <span class="">{{ openDate }}</span></span
      >
    </div>
    <div class="date">
      <v-icon
        style="color: var(--icon-grey-scale-color); margin-right: .5rem; margin-bottom: .2rem;"
        size="14"
        >mdi-clock</v-icon
      ><span
        >Close date: <span class="">{{ closeDate }}</span></span
      >
    </div>
  </div>
</template>

<script>
import * as FILTER from "../../../filters";
import * as FUNCTIONS from "../../../globalFunctions";
export default {
  name: "job-synops-card",
  props: {
    job: Object,
    status: String
  },
  data: function() {
    return {
      phone: FUNCTIONS.PHONE(),
      title: null,
      openDate: null,
      closeDate: null
    };
  },
  methods: {
    gotodetails: function() {
      this.phone &&
        this.$router
          .push({
            name: "jobdetails",
            params: { q: this.job, page: this.status }
          })
          .catch(function() {});
    }
  },
  mounted() {
    const self = this;
    if (self.job) {
      self.title = FILTER.FIRST_LETTER_CAPITAL(self.job.job_title);
      self.openDate = FUNCTIONS.MONTH_DATE_FORMAT(self.job.open_date);
      self.closeDate = FUNCTIONS.MONTH_DATE_FORMAT(self.job.close_date);
    }
  }
};
</script>

<style scoped>
.synops {
  padding: 1.5rem;
  cursor: pointer;
  border-bottom: 0.1rem solid #eeeeee;
}
.job-title {
  font-size: 1.8rem;
  font-weight: bold;
  line-height: 1.5;
  text-align: left;
  color: #050505;
  height: 2.5rem;
  overflow: hidden;
  margin-bottom: 0.5rem;
}
.date {
  font-size: 1.2rem;
  text-align: left;
}
.published {
  color: #050505;
}
.closing {
  color: #050505;
}
</style>
